export class LocalStorageHelper {
    // Saves the specified value to local storage.
    static save(key: string, value: string) : void {
        localStorage.setItem(key, value);
    }

    // Loads the specified value from local storage.
    static load(key: string) : string | null {
        return localStorage.getItem(key);
    }

    // Deletes the specified value from local storage.
    static delete(key: string) : void {
        localStorage.removeItem(key);
    }
}